import { render, staticRenderFns } from "./FactCheckerClaimsTable.vue?vue&type=template&id=1bcc98db&"
import script from "./FactCheckerClaimsTable.vue?vue&type=script&lang=js&"
export * from "./FactCheckerClaimsTable.vue?vue&type=script&lang=js&"
import style0 from "./FactCheckerClaimsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports